module.exports = __webpack_public_path__ + "static/img/41.ce8db7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/41.png
// module id = pTQc
// module chunks = 0